import { createSlice } from '@reduxjs/toolkit'

interface AppState {
  sidebarOpen: boolean
}

// Initialize sidebar state based on screen size
const getInitialSidebarState = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 1024 // lg breakpoint
  }
  return false // Default to closed on server/mobile
}

const initialState: AppState = {
  sidebarOpen: getInitialSidebarState(),
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleSidebar(state) {
      console.log('toggleSidebar called, current state:', state.sidebarOpen)
      state.sidebarOpen = !state.sidebarOpen
      console.log('toggleSidebar new state:', state.sidebarOpen)
    },
    setSidebar(state, action) {
      state.sidebarOpen = action.payload
    },
  },
})

export const { toggleSidebar, setSidebar } = appSlice.actions
export default appSlice.reducer
